<template>
  <div id="last-panel" class="flex flex-col justify-center">
    <svg-icon
      icon="heroicons/solid/check-circle"
      class="h-24 w-24 mx-auto"
      :style="{ color: survey.accentColor }"
    ></svg-icon>

    <div class="mx-auto my-10 text-center">
      <div
        v-text="title"
        class=" text-xl block mx-auto px-5 text-center "
        style="width: fit-content"
        :style="{ color: survey.fontColor, 'font-family': survey.fontFamily }"
      ></div>
    </div>

    <SurveyButton
      @click="$emit('close-widget')"
      :survey="survey"
      :step="step"
      text="Close"
    ></SurveyButton>
  </div>
</template>

<script>
import SurveyButton from "@/components/Survey/SurveyButton";
import Step from "@/models/Step";
export default {
  components: { SurveyButton },
  props: ["survey", "step"],
  computed: {
    title() {
      return this.step.title;
    },
  },
};
</script>

<style></style>
